import $ from 'jquery';


document.addEventListener( 'facetwp-loaded', () => {

	//show labels archive page
	$( '.reading-archive > .facetwp-facet' ).each( (index, el) => {
		let $facet = $( el );
		let facet_name = $facet.attr( 'data-name' );
		let facet_label = FWP.settings.labels[ facet_name ];

		if ( $facet.closest( '.facet-wrap' ).length < 1 && $facet.closest( '.facetwp-flyout' ).length < 1 ) {
			$facet.wrap( '<div class="facet-wrap"></div>' );
			$facet.before( '<div class="facet-label">' + facet_label + '</div>' );
		}
	} );

	// show custom checkboxes
	const checkbox = '.product-archive .facetwp-checkbox';
	if($(checkbox).find('span.themed-checkbox').length === 0) {
		$(checkbox).prepend('<span class="themed-checkbox"></span>');
	}
} );

document.addEventListener( 'facetwp-refresh', () => {
	let filter_element = $('.product__filters');
	let filter_button = $('.search-page__title-filter')

	if ($('.search').length && FWP.facets.search_posttype !== undefined) {
		if (FWP.facets.search_posttype[0] !== 'superunie_product') {
			filter_element.hide();
			filter_button.hide();
		} else {
			filter_element.show();
			filter_button.show();
		}
	}

	FWP.enable_scroll = FWP.soft_refresh === true;

	const in_the_kitchen = $( ".post-type-archive-gwoon_kitchen" );
	const scroll_to = $( '.breadcrumbs' )
	const container = $( "html,body" );

	//Scroll back to breadcrumb top after next page (on gwoon_kitchen post type only).
	if ( FWP.enable_scroll && in_the_kitchen.length > 0 ) {
		container.animate( {
			scrollTop: scroll_to.offset().top,
			scrollLeft: 0
		}, 300 );
	}

	//Scroll back to top after a facetwp render if not on gwoon_kitchen post type.
	if ( in_the_kitchen.length === 0 ) {
		window.scrollTo( 0, 0 );
	}
} );

//Product archive superunie_product_cat facet change redirect
$(document).on('change','#product-filters', e => {
	window.location.href = $(e.currentTarget).find('option:selected').attr('data-term-link');
});